import { render, staticRenderFns } from "./TrackBranding.vue?vue&type=template&id=1b96aa76&scoped=true&"
import script from "./TrackBranding.vue?vue&type=script&lang=js&"
export * from "./TrackBranding.vue?vue&type=script&lang=js&"
import style0 from "./TrackBranding.vue?vue&type=style&index=0&id=1b96aa76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96aa76",
  null
  
)

export default component.exports